'use client'

import { createContext } from 'react'
import type { DeviceType } from '@/utils/getIsMobileServer'

export const DeviceTypeContext = createContext<DeviceType>('desktop')
